import { render, staticRenderFns } from "./PackageInfo.vue?vue&type=template&id=ba9fafac&scoped=true&"
import script from "./PackageInfo.vue?vue&type=script&lang=js&"
export * from "./PackageInfo.vue?vue&type=script&lang=js&"
import style0 from "./PackageInfo.vue?vue&type=style&index=0&id=ba9fafac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9fafac",
  null
  
)

export default component.exports